import { Component, Input } from '@angular/core';
import { Item } from '../item';

@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.css'],
    standalone: false
})
export class ItemComponent {
  @Input() item: Item | undefined;
}